import { render } from "./ChatBotComponent.vue?vue&type=template&id=f460a7a8"
import script from "./ChatBotComponent.vue?vue&type=script&lang=js"
export * from "./ChatBotComponent.vue?vue&type=script&lang=js"

import "./ChatBotComponent.vue?vue&type=style&index=0&id=f460a7a8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__